<template>
  <div
    :class="`${color} wallet-workpackage-header`"
    :style="textcolor ? `color: ${textcolor};` : 'color: black;'"
    >
    <v-icon
      class="mr-1"
      v-if="isStandardIcon(icon)"
      :color="textcolor ? textcolor : 'black'"
      >
      {{icon}}
    </v-icon>
    <svg-icon
      class="mr-1"
      v-else-if="icon"
      :name="icon"
      :size="20"
      :style="textcolor ? `fill: ${textcolor};` : 'fill: black;'"
    />
    <slot name="step-button"/>
    <div>
      {{text}}
    </div>
    <v-spacer/>
    <slot name="step-offset"/>
    <div>
      {{taktarea_name}}
    </div>
  </div>
</template>
<script>
import {
  mapGetters,
  // mapActions
 } from 'vuex';
  export default {
    props: ['color', 'text', 'icon', 'taktarea_name', 'textcolor'],
    computed: {
      ...mapGetters('TWorkPackage', [
        'isStandardIcon'
        ],
      ),
      ...mapGetters('View', [
        'isSvgIcon'
        ],
      )
    }
  }
</script>
<style>
  .wallet-workpackage-header {
    display: flex;
    width: 100%;
    height: 16px;
    font-size: 16px;
    line-height: 16px;
    user-select: none;
    cursor: pointer;
    align-items: center;
    padding: 0px 3px 0px 3px;
    z-index: 0;
  }
</style>
